import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { SortModel } from "components/data/DataSource";
import { WebApiDataSource } from "components/data/WebApiDataSource";
import { Link } from "react-router-dom";
import * as API from "common/api/Evidence/Clenove/Prestupy";
import DataGrid, { Column, DataGridProps } from "components/controls/DataGrid";
import { Grid } from "components/controls/widget";
import StavLabel from "common/components/evidence/clenove/prestupy/StavLabel";
import NovyPrestup from "./NovyPrestup";
import PageContent from "common/web/PageContent";
import { detail as pathDetail, RouteProps } from "./routes-path";
import { UserAccess, hasUserAccess } from "common/utils/PermissionsUtils";

interface PrestupySeznamProps {
    clenId: number;
    userAccess: UserAccess;
}

declare type Props = PrestupySeznamProps & RouteComponentProps<RouteProps>;

class PrestupySeznam extends React.PureComponent<Props> {

    private dataSource: WebApiDataSource<API.PrestItem>;
    private columns: Column<API.PrestItem>[];

    constructor(props: Props) {
        super(props);

        this.dataSource = new WebApiDataSource(this.getDataAction);
        this.dataSource.setPageSize(20, true);

        const sortedItems: { [index: string]: SortModel } = {
            ['DatPorizeni']: { field: 'DatPorizeni', direction: 'desc' }
        }

        this.dataSource.setSortedItems(sortedItems);

        this.columns = [
            { headerText: "Datum", field: "DatPorizeni", width: 90, type: 'date', format: 'DD.MM.YYYY' },
            { headerText: "Přestup z", field: "PuvKlubNazev", render: this.renderPuvKlub },
            { headerText: "Přestup do", field: "NovKlubNazev", render: this.renderNovKlub },
            { headerText: "Stav", field: "Stav", width: 135, render: this.renderStav },
            { field: "_detail", width: 80, render: this.renderDetail },
        ];
    }

    renderPuvKlub = (col: Column<API.PrestItem>, row: API.PrestItem) => {
        return row.PuvKlubId ? row.PuvKlubNazev : 'divize';
    }

    renderNovKlub = (col: Column<API.PrestItem>, row: API.PrestItem) => {
        return row.NovKlubId ? row.NovKlubNazev : 'divize';
    }

    renderStav = (col: Column<API.PrestItem>, row: API.PrestItem) => {
        return <StavLabel stav={row.Stav} />;
    }

    renderDetail = (col: Column<API.PrestItem>, row: API.PrestItem) => {
        const { url } = this.props.match;
        //const { lang } = this.props;
        const link = url + pathDetail + '/' + row.Id;
        return <Link to={link}>Detail</Link>;
    }

    getDataAction = () => {
        return API.GetSeznamPrestupuClena(this.props.clenId);
    }

    render() {
        const { match, userAccess } = this.props;
        const { idtClena } = match.params;

        const dgProps: DataGridProps<API.PrestItem> = {
            dataSource: this.dataSource,
            columns: this.columns,
            //  query: this.query,
            paginationSettings: {
                pageCount: 5,
                //allowItemsCountInfo: true,
                autoHide: true,
            },
            allowPaging: true,
            //allowResizing: true,
            //allowSorting: true,
            //height: 'grow',
            // height: 300,
            // autoFitColumns:[]

            padding: 'default',
            //  padding: 'dense',
            // gridLines: 'both',
            showBorder: false,
            noItemsContent: <em>{'- není evidován žádný přestup -'}</em>,
        }

        const zobrazNovyPrestup = hasUserAccess(userAccess, UserAccess.IdtVerified | UserAccess.VerifiedPersonWrite);

        return <PageContent titles={['Přestupy']}>
            <Grid container>
                <Grid item>
                    {zobrazNovyPrestup && <NovyPrestup idtClena={Number(idtClena)} />}
                </Grid>
                <Grid item>
                    <DataGrid {...dgProps} />
                </Grid>

            </Grid>
        </PageContent>

    }
}

export default withRouter(PrestupySeznam); 
